import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import '../../assets/styles/Fatwa.css';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { groupBy } from '../../utils/lodashUtils';
import { CircularProgress } from '../../utils/materialUI';
import { Col, Row } from '../../utils/bootstrapUtils';
import { listHadiths, setHadithsIsLoadingTrue } from '../../actions/HadithActions';
import LOGO_SMALL from '../../assets/images/logo-50x51.png';
import INK_ICON from '../../assets/images/latest-fatwa.svg';
import Routes from '../../constants/routes';

class HadithsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            pageLimit: 25,
            paginationLimit: 8,
            marginPagesLimit: 1,
            isLoading: true,
        };
    }

    componentDidMount() {
        document.title = 'Hadith » Askimam';
        this.getHadiths();
    }

    componentDidUpdate() {
        let pageNo = 1;

        if (window.location.pathname.includes('page:')) {
            pageNo = window.location.pathname.split('/page:')
                .slice(-1)[0] || pageNo;
        }

        if (pageNo !== this.state.currentPage) {
            // eslint-disable-next-line
            this.setState({ currentPage: pageNo }, () => {
                this.getHadiths();
            });
        }
    }

    getHadiths = () => {
        this.props.setHadithsIsLoadingTrue();
        const offset = Math.ceil((this.state.currentPage - 1) * this.state.pageLimit);
        this.props.listHadiths(offset);
        this.setState({
            isLoading: false,
        });
    };

    handlePageClick = (data) => {
        const selected = data.selected + 1;

        let currentUrl = window.location.pathname;
        currentUrl += currentUrl.slice(-1) === '/' ? '' : '/';

        this.props.history.push({
            pathname: `${currentUrl.split('page:')[0]}page:${selected}`,
        });

        this.setState({ currentPage: selected }, () => {
            this.getHadiths();
        });
    };

    render() {
        const { hadiths } = this.props.hadiths;
        const { isLoading } = this.props.hadiths;

        const totalPages = Math.ceil(hadiths.count / 25);
        const heading = 'Category: Hadiths';

        if (this.state.isLoading) {
            return (
                <div className="loader">
                    <CircularProgress color="inherit" />
                </div>
            );
        }

        if (!isLoading && (!hadiths.results || !hadiths.results[0])) {
            return (
                <div className="result-not-found">
                    No hadith found. Please refine your search criteria.
                </div>
            );
        }

        const groupedHadiths = groupBy(hadiths.results, value => new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(new Date(value.answer.answer_modified)));

        return (
            <div>
                <Row>
                    <Col md={12}>
                        <h2 className="category-heading">
                            <img
                                src={INK_ICON}
                                className="latest-fatwas-image"
                                alt="Not available"
                            />
                            {heading}
                        </h2>
                    </Col>
                </Row>
                {
                    isLoading ?
                        <div className="loader">
                            <CircularProgress color="inherit" />
                        </div>
                        :
                        <div className="questions-holder">
                            {
                                groupedHadiths ?
                                    Object.keys(groupedHadiths)
                                        .map(date => (
                                            <div
                                                key={date}
                                                className="panel"
                                            >
                                                <div className="panel-header">
                                                    <div className="image-holder">
                                                        <img
                                                            className="logo-image"
                                                            src={LOGO_SMALL}
                                                            alt="AskImam"
                                                        />
                                                    </div>
                                                    {
                                                        date
                                                    }
                                                </div>

                                                <div className="panel-content">
                                                    <ul className="questions">
                                                        {
                                                            groupedHadiths[date].map(hadith => (

                                                                <li
                                                                    key={hadith.id}
                                                                    className="question"
                                                                >
                                                                    <Link
                                                                        className="question_link"
                                                                        to={{
                                                                            pathname: Routes.hadithDetail(hadith.old_id),
                                                                        }}
                                                                    >
                                                                        {hadith.answer.question.title}
                                                                    </Link>
                                                                </li>
                                                            ))
                                                        }
                                                    </ul>
                                                </div>
                                            </div>
                                        ))
                                    :
                                    <div className="result-not-found">
                                        No hadiths found.
                                    </div>
                            }
                        </div>
                }
                <br />
                <div className="pagination-wrapper">
                    <ReactPaginate
                        pageCount={totalPages}
                        pageRangeDisplayed={this.state.paginationLimit}
                        marginPagesDisplayed={this.state.marginPagesLimit}
                        forcePage={this.state.currentPage - 1}
                        onPageChange={this.handlePageClick}
                        previousLabel="<"
                        nextLabel=">"
                        breakLabel="..."
                        containerClassName="pages"
                        pageClassName="page"
                        previousClassName="page previous"
                        nextClassName="page next"
                        breakClassName="page break"
                        pageLinkClassName="page-link"
                        activeLinkClassName="active"
                        previousLinkClassName="page-link previous"
                        nextLinkClassName="page-link next"
                        breakLinkClassName="page-link break"
                    />
                </div>
            </div>
        );
    }
}

HadithsList.defaultProps = {
    hadiths: null,
};

HadithsList.propTypes = {
    history: PropTypes.object.isRequired,
    hadiths: PropTypes.object,
    setHadithsIsLoadingTrue: PropTypes.func.isRequired,
    listHadiths: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listhadithsReducer }) => ({
    hadiths: listhadithsReducer,
});

export default connect(mapStateToProps, {
    listHadiths,
    setHadithsIsLoadingTrue,
})(HadithsList);
